import { useEffect, useState } from "react";
import useScript from "../../const/useScript";

const Transform = () => {
  const [start, setStart] = useState(false);
  const [sec, setSec] = useState(10);

  useEffect(() => {
    setStart(true);
  }, []);

  useEffect(() => {
    let interval = setTimeout(() => {
      start && sec > 0 && setSec(sec - 1);
    }, 1000);

    if (sec === 0) window.location.href = "/";

    return () => clearTimeout(interval);
  }, [sec, start]);

  useScript("https://www.googletagmanager.com/gtag/js?id=AW-18005233054");

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `gtag('event', 'conversion', { 'send_to': 'AW-18005233054/0fTUCJrv5YYcEJ6byIlD', 'value': 1.0, 'currency': 'KRW' });`;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className=" relative w-full h-full">
      <div className=" relative w-full h-full px-[calc((100%-var(--container))/2)] my-5 pt-36 pb-28 lg:pt-52">
        <div className=" relative w-full h-full mx-auto max-w-screen-sm">
          <img
            className=" relative w-full h-auto object-contain"
            src="/images/complete.svg"
            alt="complete"
          />
        </div>
        <div className=" relative w-full h-full my-5 pb-10 text-center">
          <h3>문의 접수가 완료되어 {sec}초 뒤 메인페이지로 이동합니다.</h3>
        </div>
        <div className=" relative w-fit h-fit mx-auto ">
          <button
            type="button"
            onClick={() => (window.location.href = "/")}
            className=" relative w-fit h-fit py-1 px-10 lg:py-3 lg:px-32 bg-primary text-white rounded-full hover:shadow-lg"
          >
            <h4>메인페이지로 돌아가기</h4>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Transform;
